import { createApp } from 'vue'
import HelpList from '@/components/help/HelpList.vue'
import { loadTranslations } from '@/js/global/vue-i18n'

const app = createApp(HelpList)

loadTranslations(app).then(() => {
    app.mount("#help-list-vue")
})